import Routes from "./routes";
import GlobalStyle from "./styles/global";
import { useState } from "react";

function App() {
  const [isLogged, setIsLogged] = useState();
  const [user, setUser] = useState();
  const [isAdding, setIsAdding] = useState();
  const [isEdit, setIsEdit] = useState(false);
  const [tec, setTec] = useState();
  return (
    <>
      <GlobalStyle />
      <Routes
        tec={tec}
        setTec={setTec}
        isEdit={isEdit}
        setIsEdit={setIsEdit}
        isAdding={isAdding}
        setIsAdding={setIsAdding}
        user={user}
        setUser={setUser}
        isLogged={isLogged}
        setIsLogged={setIsLogged}
      />
    </>
  );
}

export default App;
